<template>
    <div>
        <div v-for="item in projNow" :key="item.id">
            <!-- Title page -->
            <div>
                <div class="title-img">
                    <img :src="require('../../assets/designProjects/' + item.img)">
                    <div class="title-img-overlay"></div>
                </div>
                <b-container fluid class="title-des">
                    <b-col class="col-lg-3 col-md-4 col-sm-6">
                        <h1 class="text-info text-left">{{ item.title }}</h1>
                        <p class="text-white">{{ item.description }}</p>
                    </b-col>
                </b-container>
            </div>
            <!-- Header -->
            <Header></Header>
            <!-- Project Info -->
            <b-container class="d-none d-lg-block d-xl-block content-left">
                <b-col class="col-lg-2">
                    <div class="my-5">    
                        <h5 class="text-info">Type</h5>
                        <p>{{ item.type }} <br>{{ item.skill }}</p>
                    </div>
                    <div class="my-5">    
                        <h5 class="text-info">Duration</h5>
                        <p>{{ item.time }} <br>{{ item.duration }}</p>
                    </div>
                    <!-- <div class="my-5">    
                        <h5 class="text-info">Team</h5>
                        <p>Akari Takada <br>Jack Eichenlaub <br>Victor Verboom <br>Tomasso Silluzio <br>Nancy Luu <br>Miriam Lluva</p>
                    </div>
                    <div class="my-5">
                        <h5 class="text-info">Skills</h5>
                        <p>edit here</p>
                    </div> -->
                </b-col>
            </b-container>
            <!-- Overview -->
            <b-container class="my-5">
                <h2 class="my-4 text-light">Overview</h2>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">About SIG in Groove</h5>
                            <h3>A story-based dance performance.</h3>
                            <p>SIG is a student dance crew at Keio University. Every two years the members and alumni of SIG get together to make a production called "SIG in Groove".</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <b-col md class="my-2 p-0 mr-md-4">
                            <img class="rounded-img" src="../../assets/designProjects/love/context1.png" alt="">
                            <!-- <p class="text-right w-100"><small>Source: HAPRO</small></p> -->
                        </b-col>
                        <b-col md class="my-2 p-0 mr-md-4">
                            <img class="rounded-img" src="../../assets/designProjects/love/context2.png" alt="">
                            <!-- <p class="text-right w-100"><small>Source: HAPRO</small></p> -->
                        </b-col>
                    </b-row>
                </b-col>
            </b-container>
            <!-- Problem -->
            <b-container class="bg-custom py-5 my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Current situation</h5>
                            <h3>A typical poster, for a typical show.</h3>
                            <p>Usually, the poster, pamphlet, and ticket for a show serves solely for advertising and logistic reasons.</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/love/CJM_before.png" alt="">
                        <!-- <p class="text-right w-100"><small>Source: Robin Utrecht / Getty Images</small></p> -->
                    </b-row>
                </b-col>
            </b-container>
            <b-container class="bg-problem py-5 my-5">
                <h3 class="text-white m-0">How can we use the poster, ticket, and pamphlet to create a unique experience?</h3>
            </b-container>
            <!-- Solution -->
            <b-container class="my-5">
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h5 class="text-info">Final design</h5>
                            <h3>LOVE ¯</h3>
                            <p>A poster, ticket, and pamphlet design for a dance performance that explores the different forms of love.</p>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="my-2 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/love/thumbnail.png" alt="">
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
                    <b-row class="align-items-center">
                        <b-col md>
                            <div class="my-2">
                                <h4>A ticket that triggers curiosity.</h4>
                                <p>The ticket was printed on a transparent plastic sheet and handed to the audience along with the poster.</p>
                            </div>
                        </b-col>
                        <b-col md class="my-2 p-0">
                            <div>
                                <img class="rounded-img" src="../../assets/designProjects/love/ticket.png" alt="">
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="mt-2 w-430">
                            <h4>A combination that leads to a playful interaction.</h4>
							<p>When the audience arrives, they recieve a pamphlet with striped illustrations. This is where the ticket can be used to make the illustrations come alive.</p>
						</b-col>
                    </b-row>
                    <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/love/love_mockupall.png" alt="">
                    </b-row>
                    <b-row class="my-2 justify-content-center">
                        <img class="rounded-img w-75" src="../../assets/designProjects/love/scanimation.gif" alt="">
                    </b-row>
                </b-col>
                <b-col class="my-5 col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                        <b-col class="my-2 w-430">
                            <h4>Keeping the audience engaged.</h4>
                            <p>Discovering the new purpose for the ticket keeps the audience busy especially during the wait right before the show begins.</p>
                        </b-col>
                    </b-row>
                    <b-row class="my-2">
                        <img class="rounded-img" src="../../assets/designProjects/love/CJM_after.png" alt="">
                        <!-- <p class="text-right w-100"><small>Source: Robin Utrecht / Getty Images</small></p> -->
                    </b-row>
                </b-col>
            </b-container>
            <!-- Process -->
            <!-- <b-container class="my-5">
                <b-col class="col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row>
                    <a v-b-toggle:collapse-process class="toggle-link mt-5">
                        <h2 class="mt-5 mb-4">Process</h2>
                    </a>
                    </b-row>
                </b-col>
                <b-collapse id="collapse-process">
                    <b-col class="col-lg-9 col-md-10 col-sm-12 mx-auto">
                    <b-row class="content-grp">
                        <div class="content-txt my-2">
                            <h5 class="text-info">Context</h5>
                            <h3>"To me, gaming means escape."</h3>
                            <p>Boys' with Duchenne Muscular Disease (DMD) face physical challenges due to a rapid decline of muscle function. To these boys, gaming is a gateway to independence. </p>
                        </div>
                        <div>
                            <img src="../../assets/designProjects/evo/context.png" alt="">
                        </div>
                    </b-row>
                    </b-col>
                </b-collapse>
            </b-container> -->
        </div>
        <footerProjects></footerProjects>
    </div>
</template>

<script>
import csvData from '../../data/designProjectInfo.csv'
const Header = () => import('../../components/Header.vue')
const footerProjects = () => import('../../components/footerProjects.vue')

  var now = 'love';

  export default {
    name: 'love',
    title: 'LOVE',
    components: {
      'Header': Header,
      'footerProjects': footerProjects,
    },
    data: () => {
      return {
        items : csvData
      }
    },
    computed: {
      projNow() {
        return this[this.$i18n.locale].filter((item) => item.code == now);
      },
      ja() {
        return this.items.filter((item) => item.lang == 'ja' );
      },
      en() {
        return this.items.filter((item) => item.lang == 'en');
      },
      path() {
        return this.item.path;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="@/scss/designProjects.scss">
</style>